import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export function PageShell({ children, className }: { children: ReactNode; className?: string }): JSX.Element {
  return <div className={cn("flex min-h-full flex-col gap-6", className)}>{children}</div>;
}
